import { useTheme } from '@material-ui/styles';
import darkTheme from 'config/themes/darkTheme';

const useIsDarkTheme = (): boolean => useTheme() === darkTheme;

export default useIsDarkTheme;
